import { ISyncable } from "@app/common";
import { SyncSchedule } from "@app/core";
import { SearchIndex } from "@app/orders-base";
import { IEntity } from "@messaia/cdk";
import { AddressOutput } from "../enums/address-output";
import { DirectoryAssistance } from "../enums/directory-assistance";
import { ElectronicInfo } from "../enums/electronic-info";
import { NumberUsage } from "../enums/number-usage";
import { WhitePages } from "../enums/white-pages";
import { PhoneBookPerson } from "./phone-book-person";
import { PhoneNumber } from "./phone-number";

export class PhoneBookEntry implements IEntity, ISyncable {
    id: number;
    orderId: number;
    phoneNumber: PhoneNumber;
    useFirstNewNumber: boolean | null;
    person: PhoneBookPerson = new PhoneBookPerson();
    primary: boolean = true;
    numberUsage: NumberUsage = NumberUsage.Phone;
    whitePages: WhitePages = WhitePages.No;
    electronicInfo: ElectronicInfo = ElectronicInfo.No;
    directoryAssistance: DirectoryAssistance = DirectoryAssistance.No;
    addressOutput: AddressOutput = AddressOutput.NotPublished;
    searchIndex: SearchIndex;
    inverseSearch: boolean;
    copyProhibition: boolean;
    statusMessage: string;
    entryDate: Date | string | null;
    expiryDate: Date | string | null;
    deleteStatus: boolean | null;
    assignedPhoneNumberId: number;
    syncSchedules: SyncSchedule[];
}